export const returnsListStyles = {
    noRows: {
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
    }
}
